import { SET_ACCOUNT_INFO, SET_ACCOUNT_Agree } from '../mutationTypes';

const initState = {
  accountInfo: {
    photo: '',
    email: '',
    phone: '',
  },
  agree: false,
};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};
const getters = {};
const mutations = {
  [SET_ACCOUNT_INFO](states, newValue = initState) {
    const newState = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, newState);
  },
  [SET_ACCOUNT_Agree](states, newValue = initState.agree) {
    Object.assign(states, { agree: newValue });
  },
};
const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
